import React, { useState, useEffect } from "react";
import "./Contact.css";
import { Facebook, Twitter, Instagram, CheckCircle, Cancel } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });


  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowModal("status");
    setIsLoading(true);

    try {
      const body = new URLSearchParams(formData);

      const response = await fetch("backend/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      if (response.ok) {
        setFormData({ name: "", phone: "", message: "" });
        setStatusMessage("Your message has been sent successfully!");
      } else {
        setStatusMessage("Failed to send message. Please try again.");

      }
    } catch (error) {
      console.error(error);
      setStatusMessage("An error occurred while sending your message.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      setIsLoading(false);
      setStatusMessage("");
    }
  }, [showModal]);

  return (
    <section className="contact-section">
      <div className="contact-inner">

        <div className="contact-top">
          <div className="contact-map box-shadow">
            <iframe
              title="Jooloo Furniture Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3668.62278678445!2d72.45368297588398!3d23.147459311655062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c277c6b07ac87%3A0x1cf7bd19c4253df6!2sJooloo%20Furniture!5e0!3m2!1sen!2sin!4v1753680894074!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="contact-form box-shadow">
            <h3>Send Message</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
                value={formData.name}
                onChange={handleChange}
              />

              <input
                type="tel"
                name="phone"
                placeholder="Contact Number"
                required
                pattern="[0-9]{10}"
                maxLength="10"
                inputMode="numeric"
                value={formData.phone}
                onChange={handleChange}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) e.preventDefault();
                }}
              />

              <textarea
                name="message"
                rows="3"
                placeholder="Your Message"
                required
                value={formData.message}
                onChange={handleChange}
              />

              <button type="submit">Submit</button>
              {status && <p className="status-msg">{status}</p>}
            </form>
          </div>
        </div>

        <div className="contact-logo-block">
          <h2 className="contact-logo">JOOLOO</h2>
          <p> Furniture that lasts forever.</p>
          <p>
            The advantage of hiring a workspace with us is that it gives you
            comfortable service and all-around facilities.
          </p>
        </div>

        <div className="contact-right-blocks">
          <div className="contact-block">
            <h3>Furniture</h3>
            <ul>
              <li>
                <a
                  href="#product"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById("product");
                    if (el) {
                      el.scrollIntoView({ behavior: "smooth" });
                      window.history.pushState(null, "", "/product");
                    }
                  }}
                >
                  Beds
                </a>
              </li>
              <li>
                <a
                  href="#product"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById("product");
                    if (el) {
                      el.scrollIntoView({ behavior: "smooth" });
                      window.history.pushState(null, "", "/product");
                    }
                  }}
                >
                  Chair
                </a>
              </li>
              <li>
                <a
                  href="#product"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById("product");
                    if (el) {
                      el.scrollIntoView({ behavior: "smooth" });
                      window.history.pushState(null, "", "/product");
                    }
                  }}
                >
                  All
                </a>
              </li>
            </ul>
          </div>

          <div className="contact-block">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <div className="social-item">
                <a
                  href="https://www.facebook.com/share/1Apq3eWmKf/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook fontSize="small" />
                </a>
                <span>Facebook</span>
              </div>
              <div className="social-item">
                <Twitter fontSize="small" />
                <span>Twitter</span>
              </div>
              <div className="social-item">
                <a
                  href="https://www.instagram.com/jooloo.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram fontSize="small" />
                </a>
                <span>Instagram</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Row */}
        <div className="bottom-row">
          <span className="copyright">
            Copyright © 2025, Jooloo Furnitures Pvt. Ltd.
          </span>
          <div className="legal-links">
            <button onClick={() => setShowModal("terms")}>Terms &amp; Conditions</button>
            <button onClick={() => setShowModal("privacy")}>Privacy Policy</button>
          </div>
        </div>

        <div className="footer-credits">
          Designed and Developed with
          <svg className="feather feather-code" fill="none" height="14" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24">
            <polyline points="16 18 22 12 16 6" />
            <polyline points="8 6 2 12 8 18" />
          </svg>
          and
          <svg className="feather feather-heart" fill="none" height="13" stroke="red" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
          by{" "}
          <a href="https://valkya.in/" target="_blank" rel="noreferrer">
            Valkya Creations Pvt. Ltd.
          </a>
        </div>
      </div>


      {showModal && (
        <div
          className={`contact-modal-overlay ${showModal === "terms" || showModal === "privacy" ? "centered" : ""
            }`}
        >
          <div
            className={`contact-modal-content ${showModal === "terms" || showModal === "privacy" ? "centered" : ""
              }`}
          >
            {(showModal === "terms" || showModal === "privacy") && (
              <button
                className="contact-modal-close-btn"
                aria-label="Close modal"
                onClick={() => setShowModal(null)}
              >
                &times;
              </button>
            )}

            {showModal === "terms" && (
              <>
                <h2>Terms & Conditions</h2>
                <p>
                  Welcome to Jooloo Furniture. <br />
                  By accessing or using our website, you agree to comply with these terms.
                </p>
                <ul>
                  <li>All product images are for illustration purposes. Actual colors and materials may vary.</li>
                  <li>Prices are subject to change without notice.</li>
                  <li>Orders are processed after full or partial payment confirmation.</li>
                  <li>Warranty applies only to products purchased directly from Jooloo Furniture.</li>
                  <li>We reserve the right to update these terms at any time.</li>
                </ul>
              </>
            )}

            {showModal === "privacy" && (
              <>
                <h2>Privacy Policy</h2>
                <p>
                  Your privacy is important to us. <br />
                  This policy explains how we collect, use, and protect your information.
                </p>
                <ul>
                  <li>We collect information such as name, contact number, and message through our inquiry form.</li>
                  <li>We do not share your personal details with third parties without consent.</li>
                  <li>Your data is used only to process inquiries and improve our services.</li>
                  <li>We use secure systems to protect your personal information.</li>
                  <li>By using our website, you consent to our privacy practices.</li>
                </ul>
              </>
            )}

            {showModal === "status" && (
              <>
                <div
                  className="status-icon-message"
                  style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
                >
                  {isLoading ? (
                    <CircularProgress style={{ color: "#1976d2", width: 48, height: 48 }} />
                  ) : statusMessage.toLowerCase().includes("success") ? (
                    <CheckCircle style={{ color: "green", fontSize: 48 }} />
                  ) : (
                    <Cancel style={{ color: "red", fontSize: 48 }} />
                  )}
                </div>

                <p
                  style={{
                    textAlign: "center",
                    fontSize: "1.1rem",
                    marginBottom: 20,
                    marginTop: 10,
                  }}
                >
                  {isLoading ? "Please wait..." : statusMessage}
                </p>

                {/* Show OK button only after loading completes */}
                {!isLoading && (
                  <div style={{ textAlign: "center" }}>
                    <button
                      className="contact-modal-ok-btn"
                      onClick={() => setShowModal(null)}
                    >
                      OK
                    </button>
                  </div>
                )}
              </>
            )}


          </div>
        </div>
      )}
    </section>
  );
}
